const routes = [
  {
    path: '/',
    component: () => import('@/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('@/views/Home.vue'),
        meta: {
          title: 'Statement Enquiry'
        }
      },
      {
        path: '/dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: {
          title: 'Dashboard'
        }
      },
      {
        path: '/report',
        component: () => import('@/views/Report.vue'),
        meta: {
          title: 'DA Report Status Check'
        }
      },
      {
        path: '/register',
        component: () => import('@/views/Register.vue'),
        meta: {
          title: 'ลงทะเบียน'
        }
      },
      {
        path: '/otp',
        component: () => import('@/views/Otp.vue'),
        meta: {
          title: 'ลงทะเบียน'
        }
      },
      {
        path: '/statement',
        component: () => import('@/views/Statement.vue'),
        meta: {
          title: 'Statement Enquiry'
        }
      }
    ]
  }
]

routes.push({
  path: '*',
  component: () => import('@/views/Error404.vue')
})

export default routes
